// Exported from implementation starter Redux DevTools.
import {HistoryMessage, HistoryMessageAlme} from "../types/history";

export const defaultState = {
    Window: {
        Accordion: {
            expandedPanels: { } as { [key: string]: boolean },
            shouldDisable: false,
        },
        AlmeMessage: {
            shouldDisable: false,
        },
        CallToActionButtons: {
            shouldDisable: { } as { [key: string]: boolean },
        },
        currentTree: null,
        DisplayLinks: {
            shouldDisable: false,
        },
        DisplayLinksUrl: {
            shouldDisable: false,
        },
        InlineSurveyLinks: {
            shouldDisable: { } as { [key: string]: boolean },
        },
        Input: {
            CurrentInput: '',
            StageLocation: null,
        },
        InputBoxLocked: {
            isInputBoxLocked: false,
            ReenableOnLinkClick: true,
        },
        IsMinimized: false,
        IsDragging: false,
        MinimizeButton: {
            shouldDisable: false,
        },
        NavUrl: {
            shouldDisable: false,
        },
        Position: {
            xPos: 1040,
            yPos: 213,
        },
        ReportingEvent: {
            StageLocation: null,
        },
        Size: {
            width: '414px',
            height: '549px',
        },
        SkipToContent: {
            shouldDisable: false,
            shouldSkipToContent: false,
        },
        TimeoutWarning: {
            sessionStartTime: '2020-03-09T18:49:56.124Z',
            visible: false,
            inactivityTime: '2020-03-04T17:18:32.979Z',
        },
        UserMessage: {
            shouldDisable: false,
        },
        WindowForm: {
            shouldDisable: false,
            shouldRenderForm: false,
            isMultiSelectOpen: {},
            counter: 0,
        },
    },
    Conversation: {
        AccessKey: "00000000-0000-0000-0000-000000000000",
        InputProcessing: [],
        ProcessedInput: [],
        ProcessedResponse: {
            response: {
                userId: '0cd93a95-df99-410e-b68e-cee10938e5e1',
                text: '<p>Hi, I\'m your Intelligent Virtual Assistant. I\'m programmed to help you with questions about this site. What can I help you with today?</p>',
                responseId: '00000000-0000-0000-0000-000000000000',
                responseRevision: 1,
                unitId: '00000000-0000-0000-0000-000000000000',
                displayLinkCollection: {
                    Sections: [],
                    Metadata: null,
                },
                displayLinks: [],
                displayLinkMetadata: null,
                navUrl: {
                    AutoNavigationType: 'none',
                    DisplayText: '',
                    LinkNavigationType: 'none',
                    UrlAddress: 'http://localhost:8080/?contenturl=',
                    UrlUID: '',
                    Metadata: {
                        Source: {
                            Origin: '',
                            UID: '',
                        },
                        UrlName: '',
                    },
                },
                responseActions: [],
                deferredAppCall: null,
                userDisplayName: 'You: ',
                agentDisplayName: 'Alme: ',
                maskedInput: null,
                maintainUiLock: false,
                isReverted: false,
                extensionData: {
                    entryId: '83fba2f8-d2c2-43f9-8c58-16ba786848c2',
                },
                html: [
                    {
                        tagName: 'SPAN',
                        properties: {},
                        children: [
                            {
                                tagName: 'p',
                                properties: {
                                    attributes: {},
                                },
                                children: [
                                    {
                                        text: 'Hi, I\'m your Intelligent Virtual Assistant. I\'m programmed to help you with questions about this site. What can I help you with today?',
                                    },
                                ],
                                namespace: null,
                                count: 1,
                                hasWidgets: false,
                                hasThunks: false,
                                descendantHooks: false,
                            },
                        ],
                        namespace: null,
                        count: 2,
                        hasWidgets: false,
                        hasThunks: false,
                        descendantHooks: false,
                    },
                ],
            },
            messageType: 'AppeventRequest',
            error: false,
            errorText: "",
            statusCode: "",
        },
        ReceivedResponse: {
            response: {
                userId: '0cd93a95-df99-410e-b68e-cee10938e5e1',
                text: '<p>Hi, I\'m your Intelligent Virtual Assistant. I\'m programmed to help you with questions about this site. What can I help you with today?</p>',
                responseId: '00000000-0000-0000-0000-000000000000',
                responseRevision: 1,
                unitId: '00000000-0000-0000-0000-000000000000',
                displayLinkCollection: {
                    Sections: [],
                    Metadata: null,
                },
                displayLinks: [],
                displayLinkMetadata: null,
                navUrl: {
                    AutoNavigationType: 'none',
                    DisplayText: '',
                    LinkNavigationType: 'none',
                    UrlAddress: 'http://localhost:8080/?contenturl=',
                    UrlUID: '',
                    Metadata: {
                        Source: {
                            Origin: '',
                            UID: '',
                        },
                        UrlName: '',
                    },
                },
                responseActions: [],
                deferredAppCall: null,
                userDisplayName: 'You: ',
                agentDisplayName: 'Alme: ',
                maskedInput: null,
                maintainUiLock: false,
                isReverted: false,
                extensionData: {
                    entryId: '83fba2f8-d2c2-43f9-8c58-16ba786848c2',
                },
                html: [
                    {
                        tagName: 'SPAN',
                        properties: {},
                        children: [
                            {
                                tagName: 'p',
                                properties: {
                                    attributes: {},
                                },
                                children: [
                                    {
                                        text: 'Hi, I\'m your Intelligent Virtual Assistant. I\'m programmed to help you with questions about this site. What can I help you with today?',
                                    },
                                ],
                                namespace: null,
                                count: 1,
                                hasWidgets: false,
                                hasThunks: false,
                                descendantHooks: false,
                            },
                        ],
                        namespace: null,
                        count: 2,
                        hasWidgets: false,
                        hasThunks: false,
                        descendantHooks: false,
                    },
                ],
            },
            messageType: 'AppeventRequest',
        },
        ResponseProcessing: null,
        SentInput: {
            request: {
                userId: '0cd93a95-df99-410e-b68e-cee10938e5e1',
                sessionId: 'c267e3c5-8d18-4a45-8e0b-7f7ecdf3c69c',
                eventName: 'WelcomeUser',
                origin: 'Internal',
                parameters: {
                    LaunchPointName: '',
                    LaunchParameter: '',
                    LaunchType: '',
                    Context: {
                        CurrentUrl: {
                            AbsolutePath: 'http://localhost:8080/',
                            Protocol: 'http:',
                            Host: 'localhost:8080',
                            HostName: 'localhost',
                            Port: '8080',
                            Uri: '/',
                            Query: '',
                            Fragment: '',
                            Origin: 'http://localhost:8080',
                            Type: 'embedded',
                            PageName: 'Alme Test Page',
                        },
                    },
                    UiVersion: '0.1.0',
                },
                channel: 'Web',
                language: 'en-US',
                accessKey: '00000000-0000-0000-0000-000000000000',
            },
            messageType: 'AppeventRequest',
        },
        SessionId: 'c267e3c5-8d18-4a45-8e0b-7f7ecdf3c69c',
        CustomSessionId: "",
        UserId: '0cd93a95-df99-410e-b68e-cee10938e5e1',
        Language: 'en-US',
        Channel: 'Web',
        PageLoadActions: [],
        IsActiveSession: true,
        UserMetadata: {},
    },
    History: {
        HistoryMessages: [
            {
                type: 'AlmeResponseType',
                responseRevision: 2,
                text: "Hi, I'm your Intelligent Virtual Assistant. I'm programmed to help you with questions about this site. What can I help you with today?",
                navUrl: null,
                displayLinkCollection: {
                    Sections: [],
                    Metadata: null,
                },
                responseActions: [],
                extensionData: {
                    entryId: '83fba2f8-d2c2-43f9-8c58-16ba786848c2',
                },
            } as HistoryMessageAlme,
        ] as HistoryMessage[],
        RawMessages: [],
    },
    PersistentStorage: {
        NITAlme: {
            'CommandAction.PageLoadActions': [],
            'Conversation.SessionId': 'c267e3c5-8d18-4a45-8e0b-7f7ecdf3c69c',
            'Window.IsMinimized': false,
            'Window.Position': {
                xPos: 1040,
                yPos: 213,
            },
            'Window.Size': {
                width: '414px',
                height: '549px',
            },
            "JwtAuthentication.almeKey": "",
        },
        NITAlmeUser: {
            'Conversation.UserId': '0cd93a95-df99-410e-b68e-cee10938e5e1',
        },
    },
    AutoNav: {
        StagedNav: {
            AutoNavigationType: 'none',
            DisplayText: '',
            LinkNavigationType: 'none',
            UrlAddress: 'http://localhost:8080/?contenturl=',
            UrlUID: '',
            Metadata: {
                Source: {
                    Origin: '',
                    UID: '',
                },
                UrlName: '',
            },
        },
    },
    WelcomeUser: {
        SuppressAction : [''] 
    },
    ClientCommunicator: {
        ReceivedMessages: [],
        AllowedOrigins: [
            'http://localhost:80',
            'https://localhost:80',
            'http://localhost:8080',
            'https://localhost:8080',
            'http://http://localhost',
            'https://http://localhost',
            'http://https://localhost',
            'https://https://localhost',
            'http://http://localhost:8080',
            'https://http://localhost:8080',
            'http://https://localhost:8080',
            'https://https://localhost:8080',
            'http://http://hm-dev01.ebu.nextnet.com',
            'https://http://hm-dev01.ebu.nextnet.com',
            'http://https://hm-dev01.ebu.nextnet.com',
            'https://https://hm-dev01.ebu.nextnet.com',
            'http://http://hm-imp01.ebu.nextnet.com',
            'https://http://hm-imp01.ebu.nextnet.com',
            'http://https://hm-imp01.ebu.nextnet.com',
            'https://https://hm-imp01.ebu.nextnet.com',
            'http://http://hm-imp02.ebu.nextnet.com',
            'https://http://hm-imp02.ebu.nextnet.com',
            'http://https://hm-imp02.ebu.nextnet.com',
            'https://https://hm-imp02.ebu.nextnet.com',
        ],
    },
    Initialization: {
        InitializationCompleted: true,
        LaunchInitializationCompleted: true,
    },
    DeviceType: 'Desktop',
    CommandAction: {
        PageLoadActions: [],
    },
    JwtAuthentication: {
        almeKey: "",
    },
    Survey: {
        Comment: "",
        EntryId: "",
        metaData: {},
        reason: "",
        selectedReasonIndex: "",
        surveyId: "",
        SurveyUnitLabel: "",
        visible: false,
    },   
};

export type AlmeState = typeof defaultState;



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/wireup/AlmeState.ts